import { useRouteMatch } from "react-router-dom";

import { useMentionCards } from "@/contexts/MentionCardsContext";
import { ROUTES } from "@/routes_new";
import Modal, { ModalContent, ModalTitle } from "@components/Modal";
import { ModalProps } from "@components/Modal/Modal";

import Share from "./partials/Share";

import styles from "./TagShareModal.module.css";

const TagShareModal = (modalProps: ModalProps) => {
  const { tag } = useMentionCards();
  const isFavoritePage = useRouteMatch(ROUTES.FAVORITES_ORGID)?.isExact;

  if (!tag && !isFavoritePage) return null;

  return (
    <Modal className={styles.modal} {...modalProps}>
      <ModalTitle>
        {isFavoritePage
          ? L.SHARE_FAVORITES
          : L.SHARE_TAG_MODAL_TITLE.replaceAll("{}", `"${tag?.name}"`)}
      </ModalTitle>

      <ModalContent>
        <Share />
      </ModalContent>
    </Modal>
  );
};

export default TagShareModal;
